import React, { useState } from 'react'
import { FAQManager } from '@/shared/ui'
import { 
  useFAQList, 
  useCreateFAQ, 
  useUpdateFAQ, 
  useDeleteFAQ,
  usePagination 
} from '@/shared/hooks'
import type { FAQCreateRequest, FAQUpdateRequest } from '@/shared/api'

export const FAQPage: React.FC = () => {
  const [search, setSearch] = useState('')
  const { page, limit, setPage } = usePagination()
  
  const { data, isLoading, error } = useFAQList({
    page,
    limit,
    search: search || undefined,
    include_inactive: false
  })
  
  const createFAQ = useCreateFAQ()
  const updateFAQ = useUpdateFAQ()
  const deleteFAQ = useDeleteFAQ()

  const handleCreate = (title: string, description: string, sortOrder?: number) => {
    const request: FAQCreateRequest = {
      title,
      description,
      sort_order: sortOrder
    }
    createFAQ.mutate(request)
  }

  const handleUpdate = (
    id: number, 
    title?: string, 
    description?: string, 
    isActive?: boolean, 
    sortOrder?: number
  ) => {
    const request: FAQUpdateRequest = {
      title,
      description,
      is_active: isActive,
      sort_order: sortOrder
    }
    updateFAQ.mutate({ id, request })
  }

  const handleDelete = (id: number) => {
    deleteFAQ.mutate(id)
  }

  return (
    <FAQManager
      title="FAQ (Частые вопросы)"
      description="Управление часто задаваемыми вопросами для мобильного приложения"
      data={data?.items || []}
      loading={isLoading}
      error={error}
      includeInactive={false}
      onToggleInactive={undefined}
      onCreate={handleCreate}
      onUpdate={handleUpdate}
      onDelete={handleDelete}
      isCreating={createFAQ.isPending}
      isUpdating={updateFAQ.isPending}
      isDeleting={deleteFAQ.isPending}
    />
  )
}
